import React from "react";
import { BRAND_WORDMARK_PATH } from "@/constants/brandAssets";
import { PRODUCT_DISPLAY_NAME } from "@/utils/seoUtils";

const DEFAULT_ALT = PRODUCT_DISPLAY_NAME;

type BrandLogoProps = React.ImgHTMLAttributes<HTMLImageElement>;

/** Site wordmark lockup (`public/wordmarkDark.svg`). */
export function BrandLogo({
  alt = DEFAULT_ALT,
  className,
  ...props
}: BrandLogoProps) {
  const merged = ["brand-logo", className].filter(Boolean).join(" ");
  return (
    <img
      src={BRAND_WORDMARK_PATH}
      alt={alt}
      className={merged}
      // The SVG's own intrinsic size; CSS sets the rendered width. Lets the
      // browser reserve the aspect ratio before the file loads.
      width={2176}
      height={384}
      decoding="async"
      loading="eager"
      {...props}
    />
  );
}

/** @deprecated Use `BrandLogo` — same wordmark asset. */
export function BrandLogoWordmark(props: BrandLogoProps) {
  return <BrandLogo {...props} />;
}
